/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";

/**
 * Creates a detail query hook for /item/id/{id} endpoints.
 * All detail endpoints follow the same pattern — resource name + ID in URL.
 *
 * Usage:
 *   export const useService = createDetailQuery(queryKeys.service.detail, "/public/services");
 */
export const createDetailQuery = (keyFn, baseUrl) => {
  return (id, queryParams) =>
    useQuery({
      queryKey: keyFn(id),
      queryFn: () => fetcher({ method: "GET", url: `${baseUrl}/item/id/${id}` }),
      ...queryParams,
    });
};
